






import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CreateOrEditForm from "wallet/components/address/CreateOrEditForm.vue";
import mixins from "@/mixins";

@Component({
  components: {
    CreateOrEditForm
  }
})
class CreateAddressPage extends Mixins(mixins.page) {
  @Getter("wallet/mixin/getAssetById") getAssetById;

  get title() {
    return this.$t("common.addresses.create") as string;
  }

  get id() {
    return this.$route.params.id as string;
  }

  get asset() {
    return this.getAssetById(this.id);
  }

  get pageTitle() {
    return this.$t("common.addresses.create");
  }
}
export default CreateAddressPage;
